export const EGLISE = {
  nom: "Centre Missionnaire Philadelphie · Lubumbashi",
  adresse:
    "17 Avenue Nyangwe I, Quartier Lido, Commune de Lubumbashi Lubumbashi",
  lat: -11.6657936,
  lng: 27.4674237,
};
export const WHATSAPP_URL = "https://wa.me/+243816681958";
export const MAPS_URL = `https://www.google.com/maps/dir/?api=1&destination=${EGLISE.lat},${EGLISE.lng}`;

export const PHONE_NUMBER = "+243 816 681 958";
export const PHONE_TEL_URL = "tel:+243816681958";

// Réseaux sociaux officiels du CMP Lubumbashi
export const YOUTUBE_URL = "https://www.facebook.com/CMPLubumbashi";
export const FACEBOOK_URL = "https://www.youtube.com/@CMPLubumbashi";
export const INSTAGRAM_URL = "https://www.instagram.com/cmplubumbashi";
export const TIKTOK_URL = "https://www.tiktok.com/@cmplubumbashi25";
export const WHATSAPP_CHANNEL_URL =
  "https://www.whatsapp.com/channel/0029VaoVVieIiRon8ltEFR15";
